export const state = {
  loading: false,
  isOpen: false,
}
